import React from "react";

import { Row, Col, Container } from "react-bootstrap";
import { MdDevices, MdLocationPin, MdAccessTime } from "react-icons/md";

import Feature from "./Feature";
import HOMEDEVICESDESKTOP from "../images/devicesDesktopTransparent.png";
import HOMEDEVICESMOBILE from "../images/devicesMobile.png";
import { PALETTE } from "../../common/ThemeConstants";
import { useWindowWidth } from "../../api/useWindowWidth";

export default function HomeFeaturesBottom() {
  const [_, isMobile] = useWindowWidth()
  let devicesImage = HOMEDEVICESDESKTOP;
  if (isMobile) {
    devicesImage = HOMEDEVICESMOBILE;
  } else {
    devicesImage = HOMEDEVICESDESKTOP;
  }
  return (
    <Container>
      <Row className="text-center">
        <Col>
          <h1 style={{ color: PALETTE.DARK }}>
            2. Trova <span style={{ fontWeight: "bold" }}>il tuo modo</span>{" "}
            di allenarti
          </h1>
          <p style={{ color: PALETTE.DARK }}>
            Allenati ovunque e in qualsiasi momento grazie alla versione
            mobile dell'App
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <img src={devicesImage} style={{ maxWidth: "100%" }} />
        </Col>
      </Row>
      <Row
        className="justify-content-center align-items-end m-auto pt-4 pb-1"
        style={{ width: "100%" }}
      >
        <Col className="px-1">
          <Feature
            icon={<MdDevices color={PALETTE.DARK} size={34} />}
            title={"Con qualsiasi dispositivo"}
          />
        </Col>
        <Col className="px-1">
          <Feature
            icon={<MdLocationPin color={PALETTE.DARK} size={34} />}
            title={"Ovunque tu sia"}
          />
        </Col>
        <Col className="px-1">
          <Feature
            icon={<MdAccessTime color={PALETTE.DARK} size={34} />}
            title={"A qualunque ora"}
          />
        </Col>
      </Row>
    </Container>
  );
}
